import type { Article } from "./types";

export const cleaningRoutinesArticles: Article[] = [];
